<template>
    <div>
        <h1>{{ $t('form.order_salt.header_main') }}</h1>
        <transition name="slide-fade" v-if="!fetchingLastOrder && lastOrder">
            <div class="block has-small-margin-bottom has-no-top-margin order-information">
                <div class="information-header">
                    <h2>{{ $t('form.order_salt.has_ordered_information.thank_you_time') }}</h2>
                    <h4>{{ $t('form.order_salt.has_ordered_information.successfully_requested') }} {{ getDateLabel() }}
                    </h4>
                </div>
                <div class="information-body">
                    <div class="body-content">
                        <img src="static/img/icons/calendar.svg" class="content-icon" alt="calendar icon" />
                        <p>{{ $t('form.order_salt.has_ordered_information.email_calendar') }}</p>
                    </div>
                    <div class="body-content">
                        <img src="static/img/icons/mail.svg" class="content-icon" alt="mail icon" />
                        <p>{{ $t('form.order_salt.has_ordered_information.email_mail') }}</p>
                    </div>
                    <div class="body-content">
                        <img src="static/img/icons/location.svg" class="content-icon" alt="location icon" />
                        <p>{{ $t('form.order_salt.has_ordered_information.location') }}</p>
                    </div>
                </div>
                <hr class="border">
                </hr>
                <div class="information-footer">
                    <h4>{{ $t('form.order_salt.has_ordered_information.phone') }}</h4>
                    <div class="footer-contact">
                        <img src="static/img/icons/phone.svg" class="icon-small" alt="location icon" />
                        <p>0800 / 24 550</p>
                    </div>
                </div>
            </div>
        </transition>
        <loader :loading="fetchingAvailableContactMoments" :error="errorFetchingAvailableContactMoments">
            <div class="row">
                <div v-if="!fetchingAvailableContactMoments && availableContactMoments && !lastOrder"
                    class="col-12 col-md-12 col-l-12 col-xl-10">
                    <div class="block has-small-margin-bottom">
                        <h2>{{ $t('form.order_salt.header_sub') }}</h2>
                        <p>{{ $t('form.order_salt.label_info') }}</p>
                        <p><b>{{ $t('form.order_salt.available_dates') }}</b></p>
                        <p v-if="availableContactMoments && availableContactMoments.length === 0">
                            {{ $t('form.order_salt.no_available_dates_found') }}</p>
                        <div class="row justify-content-center order-container">
                            <div v-for="option in availableContactMoments" @click="selectOption(option)"
                                :key="option.date" class="container-option"
                                :class="selectedOption === option ? 'selected' : ''">
                                <div v-if="option.label" class="date-label" :class="option.label.toLowerCase()"
                                    @click.stop="toggleTooltip(option.date)">
                                    <span>{{ $t('form.order_salt.label_' + option.label) }}</span>
                                    <i v-html="infoIcon()"></i>
                                    <div v-if="activeTooltip === option.date" class="tooltip">
                                        <span> {{ renderLabelTooltip(option.label) }}</span>
                                        <i>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11"
                                                viewBox="0 0 12 11" fill="none">
                                                <path
                                                    d="M5.10557 10.2111C5.4741 10.9482 6.5259 10.9482 6.89443 10.2111L11.2764 1.44721C11.6088 0.782312 11.1253 0 10.382 0H1.61803C0.874652 0 0.391156 0.782312 0.723607 1.44721L5.10557 10.2111Z"
                                                    fill="#322F35" />
                                            </svg>
                                        </i>
                                    </div>
                                </div>
                                <p class="day-name">{{ useMoment(option.date, 'YYYY-MM-DD', 'dddd') }}</p>
                                <h2 class="day-date">{{ useMoment(option.date, 'YYYY-MM-DD', 'D MMM').replace('.', '')
                                }}
                                </h2>
                                <div class="co2-icon">
                                    <span>{{ $t('form.order_salt.co2_saved') }}:</span>
                                    <div v-html="renderCO2Icons(option.label)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row gap-y-1">
                        <div class="col-xl-6">
                            <div class="block has-no-top-margin has-small-margin-bottom has-small-padding-top">
                                <div class="address-header">
                                    <h4>{{ $t('form.installation.appointment.address') }}</h4>
                                </div>
                                <div class="address-group">
                                    <p v-for="(value) in address">
                                        {{ value ? value : '-' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="block has-no-top-margin has-small-margin-bottom has-small-padding-top">
                                <h4>{{ $t('form.appointment.label_comment') }}</h4>
                                <textarea class="block__textarea form__input--textarea border_dark" v-model="comment"
                                    :placeholder="$t('form.appointment.placeholder_comment')"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid no-padding">
                        <div class="flex justify-content-end ">
                            <button class="button--cta no-margin-x" @click="onSubmit" :disabled="disabled">{{
                                $t('form.order_salt.button_submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </loader>
    </div>
</template>
<script>
import Vue from 'vue';
import {
    SUBMIT_ORDER,
    SET_SUBMITTING_ORDER,
    GET_SUBMITTING_ORDER
} from '../store/modules/order_salt';
import {
    FETCH_LAST_ORDER,
    GET_LAST_ORDER,
    GET_FETCHING_LAST_ORDER
} from '../store/modules/orders';
import { GET_FIELD } from '../store/modules/account_details';
import { Component, Watch } from 'vue-property-decorator';
import {
    FETCH_AVAILABLE_CONTACT_MOMENTS,
    GET_AVAILABLE_CONTACT_MOMENTS,
    GET_FETCHING_AVAILABLE_CONTACT_MOMENTS,
    GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS,
    GET_SELECTED_OPTION,
    SET_SELECTED_OPTION,
    GET_COMMENT,
    SET_COMMENT,
    SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS
} from '../store/modules/available_contact_moments';
import Loader from '../components/general/Loader.vue';
import moment from 'moment';
import Raven from 'raven-js';

@Component({
    components: { Loader }
})
export default class OrderSaltBlocks extends Vue {
    address = {
        full_name: '',
        street: '',
        number: '',
        postalCode: '',
        city: '',
        country: ''
    }
    activeTooltip = null;

    get submittingOrder() {
        return this.$store.getters[GET_SUBMITTING_ORDER];
    }

    get fetchingLastOrder() {
        return this.$store.getters[GET_FETCHING_LAST_ORDER];
    }

    get selectedOption() {
        return this.$store.getters[GET_SELECTED_OPTION];
    }

    get fetchingAvailableContactMoments() {
        return this.$store.getters[GET_FETCHING_AVAILABLE_CONTACT_MOMENTS];
    }

    get errorFetchingAvailableContactMoments() {
        return this.$store.getters[GET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS];
    }

    get comment() {
        return this.$store.getters[GET_COMMENT];
    }

    set comment(value) {
        this.$store.commit(SET_COMMENT, value);
    }

    created() {
        this.fetchLastOrder();
        this.fetchAvailableOptions();
        this.setAddress();
    }

    @Watch('accountFields', { deep: true })
    onAccountFieldsChange() {
        this.setAddress();
    }

    get accountFields() {
        return this.$store.state.account_details.fields;
    }

    async fetchLastOrder() {
        try {
            await this.$store.dispatch(FETCH_LAST_ORDER);
        } catch (e) {
            //if the last order is not available, dont give error.
            this.$notify.error(this.$t('form.account_info.notify_failure'));
        }
    }

    async fetchAvailableOptions() {
        try {
            await this.$store.dispatch(FETCH_AVAILABLE_CONTACT_MOMENTS);
        } catch (e) {
            this.$store.commit(SET_ERROR_FETCHING_AVAILABLE_CONTACT_MOMENTS, this.$t('form.order_salt.error_fetching_available_contact_moments'));
        }
    }

    async onSubmit() {
        if (!this.disabled) {
            this.$store.commit(SET_SUBMITTING_ORDER, true);
            try {
                let payload = {
                    date: this.selectedOption.date,
                    comment: this.comment,
                    driver_id: this.selectedOption.driver_id
                };
                await this.$store.dispatch(SUBMIT_ORDER, payload);
                this.$notify.success(this.$t('form.order_salt.notify_success'));
            } catch (e) {
                if (e.response && e.response.data && e.response.data.message) {
                    this.$notify.error(e.response.data.message);
                    await this.fetchAvailableOptions();
                } else {
                    this.$notify.error(this.$t('form.order_salt.notify_failure'));
                }
                Raven.captureException(e);
            } finally {
                this.$store.commit(SET_SUBMITTING_ORDER, false);
            }
            await this.fetchLastOrder();
        }

    }

    setAddress() {
        const addressValue = this.getFieldValue('address');
        if (!addressValue || addressValue === 'address') {
            // Data not ready yet, watcher will call this method again when it's available
            return;
        }

        // Set address fields from store data
        this.address.full_name = this.getFieldValue('name');
        this.address.street = addressValue;
        this.address.number = this.getFieldValue('address_number');
        this.address.postalCode = this.getFieldValue('postal_code');
        this.address.city = this.getFieldValue('city_name');
        this.address.country = this.getFieldValue('country_name');
    }

    selectOption(option) {
        this.activeTooltip = null;
        this.$store.commit(SET_SELECTED_OPTION, option);
    }

    getFieldValue(field) {
        return this.$store.getters[GET_FIELD](field);
    }


    get lastOrder() {
        if (this.$store.getters[GET_LAST_ORDER] !== null && this.$store.getters[GET_LAST_ORDER] !== undefined) {
            if (this.$store.getters[GET_LAST_ORDER].hasOwnProperty('completed') && this.$store.getters[GET_LAST_ORDER].hasOwnProperty('created')) {
                if (this.$store.getters[GET_LAST_ORDER].completed === false) {
                    return this.$store.getters[GET_LAST_ORDER];
                } else return false;
            }
        } else {
            return false;
        }
    }

    get availableContactMoments() {
        return this.$store.getters[GET_AVAILABLE_CONTACT_MOMENTS];
    }

    get disabled() {
        return this.submittingOrder || this.fetchingLastOrder || !this.selectedOption || this.lastOrder;
    }

    getDateLabel() {
        const date = this.lastOrder.action_timestamp;
        if (date) {
            return moment(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll') ?
                moment(date, 'DD-MM-YYYY hh:mm:ss').format('ddd ll')
                :
                date;
        }
    }

    useMoment(date, format, output) {
        return moment(date, format).format(output);
    }

    infoIcon() {
        return `
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                  <g clip-path="url(#clip0_5016_215)">
                    <path d="M5.49984 10.5834C8.03114 10.5834 10.0832 8.53139 10.0832 6.00008C10.0832 3.46878 8.03114 1.41675 5.49984 1.41675C2.96853 1.41675 0.916504 3.46878 0.916504 6.00008C0.916504 8.53139 2.96853 10.5834 5.49984 10.5834Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.5 7.83341V6.00008M5.5 4.16675H5.50458" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_5016_215">
                      <rect width="11" height="11" fill="white" transform="translate(0 0.5)"/>
                    </clipPath>
                  </defs>
              </svg>
            `;
    }

    toggleTooltip(date) {
        this.activeTooltip = this.activeTooltip === date ? null : date;
    }
    renderLabelTooltip(label) {
        return this.$t(`form.order_salt.label_${label}_tooltip`);
    }

    CO2Icon() {
        return `
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.73345 1.59728L6.92777 1.20995C6.86771 1.17724 6.80095 1.16016 6.73317 1.16016C6.6654 1.16016 6.59863 1.17724 6.53857 1.20995L6.73345 1.59728Z" fill="#375278"/>
                <path d="M7.50579 12.2195C8.75382 12.0889 9.91076 11.4799 10.7521 10.5108C11.5934 9.54174 12.0591 8.28164 12.0589 6.97506C12.0589 4.74911 10.8036 2.99252 9.62516 1.82896C8.9629 1.17978 8.23381 0.60882 7.45115 0.126474C7.38562 0.0865407 7.31951 0.0476569 7.25284 0.00983685L7.2407 0.0028105L7.23665 0.000702584C7.23665 0.000702584 7.23463 4.18803e-08 6.99989 0.46655L6.76583 0H6.76448L6.7638 0.000702584L6.75976 0.0028105L6.74762 0.00983685C6.68062 0.0470495 6.6145 0.08594 6.5493 0.126474C5.76664 0.60882 5.03755 1.17978 4.3753 1.82896C3.19689 2.99252 1.94092 4.74911 1.94092 6.97506C1.94082 8.28152 2.40661 9.54145 3.24792 10.5104C4.08923 11.4793 5.24607 12.0882 6.49399 12.2188V13.473C6.49399 13.6128 6.54729 13.7468 6.64217 13.8457C6.73704 13.9445 6.86572 14 6.99989 14C7.13406 14 7.26274 13.9445 7.35761 13.8457C7.45249 13.7468 7.50579 13.6128 7.50579 13.473V12.2195ZM7.50579 11.1585V9.63242L9.4599 8.22926C9.57037 8.14987 9.64604 8.02803 9.67026 7.89053C9.69449 7.75303 9.66528 7.61113 9.58907 7.49606C9.51286 7.38099 9.39589 7.30217 9.26389 7.27693C9.13189 7.2517 8.99567 7.28212 8.8852 7.36151L7.50579 8.35222V6.31528L9.04641 5.11448C9.14954 5.02916 9.21665 4.90531 9.2335 4.76925C9.25035 4.6332 9.2156 4.49566 9.13664 4.38587C9.05768 4.27608 8.94073 4.20269 8.81065 4.1813C8.68056 4.15991 8.5476 4.1922 8.44001 4.27132L7.50579 4.99925V3.45064C7.50579 3.38144 7.4927 3.31291 7.46728 3.24898C7.44185 3.18504 7.40459 3.12695 7.35761 3.07801C7.31064 3.02908 7.25487 2.99026 7.19349 2.96378C7.13211 2.93729 7.06633 2.92366 6.99989 2.92366C6.93345 2.92366 6.86767 2.93729 6.80629 2.96378C6.74491 2.99026 6.68914 3.02908 6.64217 3.07801C6.59519 3.12695 6.55793 3.18504 6.5325 3.24898C6.50708 3.31291 6.49399 3.38144 6.49399 3.45064V4.99925L5.56112 4.27132C5.45353 4.1922 5.32056 4.15991 5.19048 4.1813C5.0604 4.20269 4.94345 4.27608 4.86449 4.38587C4.78553 4.49566 4.75078 4.6332 4.76763 4.76925C4.78448 4.90531 4.85159 5.02916 4.95472 5.11448L6.49467 6.31599V8.35292L5.11525 7.36221C5.00479 7.28895 4.87136 7.26316 4.74302 7.29027C4.61468 7.31738 4.50143 7.39527 4.42709 7.50756C4.35275 7.61986 4.3231 7.7578 4.34439 7.8924C4.36568 8.02699 4.43623 8.14774 4.54123 8.22926L6.49467 9.63313V11.1585C5.51663 11.0302 4.61719 10.5344 3.96517 9.76428C3.31315 8.99415 2.95338 8.0026 2.95339 6.97576C2.95339 5.17631 3.97395 3.679 5.07208 2.59483C5.66118 2.0175 6.30791 1.50753 7.00124 1.07363C7.69456 1.50753 8.3413 2.0175 8.93039 2.59483C10.0279 3.679 11.0484 5.17631 11.0484 6.97576C11.0484 8.0026 10.6887 8.99415 10.0366 9.76428C9.38462 10.5344 8.48517 11.0302 7.50714 11.1585" fill="#272926"/>
              </svg>
            `;
    }

    renderCO2Icons(label) {
        const count = label === 'suggested' ? 3 : label === 'alternative' ? 2 : 1;
        return this.CO2Icon().repeat(count);
    }

    get contactUrl() {
        return this.$t('account_info.address_information_contact_url');
    }

}
</script>



// WEBPACK FOOTER //
// src/pages/OrderSaltBlocks.vue